module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasContent) ? _c('div', {
    staticClass: "sidebar-block",
    class: {
      "sidebar-block__center": _vm.textAlignCenter
    }
  }, [(_vm.title) ? _c(_vm.tag, {
    tag: "component",
    staticClass: "sidebar-block__title"
  }, [_vm._v(_vm._s(_vm.title) + ": ")]) : _vm._e(), _c(_vm.tag, {
    tag: "component",
    class: {
      "inline-value": _vm.inlineValuesElements
    }
  }, [_vm._t("default")], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6d8e95","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/sidebar/components/SidebarElement.vue
// module id = 825b1c8b12a2a7c82ee4
// module chunks = 0